module.exports = __webpack_public_path__ + "static/img/icon-money.49abe2b.png";